export const officeOpenTime = '08:59';
export const officeCloseTime = '16:01';
